<template>
  <div class="stats-card" >
    <div class="stats-icon" v-if="icon">

      <component :is="`icon-${icon}`" v-if="icon !== '#'" />
    </div>
    <div class="stats-title" :title="title">{{ title }}</div>
    <div class="stats-value">{{ value }}</div>
  </div>
</template>

<script>

  export default {
  name: 'HomeStatsCard',
  components:{
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style scoped>
.stats-card {
  background: var(--color-bg-3);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 20px 24px 16px 24px;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  overflow: hidden;
}
.stats-icon {
  font-size: 32px;
  margin-bottom: 8px;
  color: var(--color-text-2);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stats-title {
  font-size: 15px;
  color: var(--color-text-1);
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stats-value {
  font-size: 20px;
  font-weight: 700;
  color: dodgerblue;
  letter-spacing: 1px;
  font-family: 'DIN Alternate', 'Arial', sans-serif;
  text-shadow: 0 1px 2px rgba(30,144,255,0.5);
}
</style>